import { useCallback, useEffect, useState } from "react";
import { TabItem } from "./Tabs";

export interface TabsController {
    activeValue?: string | number;
    setActiveValue: (value: string) => void;
    handleTabChange: (tabId: string | number) => void;
}

export interface UseTabsControllerOptions {
    defaultValue?: string | number;
    value?: string | number;
    onChange?: (value: string | number) => void;
}

export function useTabsController({ defaultValue, value, onChange }: UseTabsControllerOptions): TabsController {
    const [internalValue, setInternalValue] = useState<string | number | undefined>(defaultValue);

    const activeValue = value !== undefined ? value : internalValue;

    const handleTabChange = useCallback(
        (tabId: string | number) => {
            if (value === undefined) {
                setInternalValue(tabId);
            }
            onChange?.(tabId);
        },
        [value, onChange]
    );

    const setActiveValue = useCallback(
        (newValue: string) => {
            handleTabChange(newValue);
        },
        [handleTabChange]
    );

    useEffect(() => {
        if (defaultValue !== internalValue) {
            setInternalValue(defaultValue);
        }
    }, [defaultValue, internalValue, setInternalValue]);

    return {
        activeValue,
        setActiveValue,
        handleTabChange,
    };
}
